import { useEffect } from 'react'
import PropTypes from 'prop-types'

import styles from './Modal.module.css'

import Modal, { ModalBody, ModalHeader } from '../Modal'
import Button from 'Design/components/Button'
import Heading from 'Design/components/Heading'

const PromptModal = (props) => {
  const { isOpen, title = 'Confirm Navigation', message, onCancel, onProceed, isConfirmButtonDisabled } = props

  useEffect(() => {
    const handleKeydown = (e) => {
      if (onProceed && isOpen && e.key === 'Enter') {
        onProceed()
      }
    }

    window.addEventListener('keydown', handleKeydown)
    return () => window.removeEventListener('keydown', handleKeydown)
  }, [onProceed, isOpen])

  return (
    <Modal
      isOpen={isOpen}
      contentLabel='Prompt Modal'
      ariaHideApp={false}
      onRequestClose={onCancel}
      className={styles.Modal}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader onClose={onCancel}>
        <Heading>{title}</Heading>
      </ModalHeader>
      <ModalBody>
        <div className='modal-body'>
          <Heading level={2}>{message}</Heading>
        </div>
        <div className={styles.ModalFooter}>
          <Button className={styles.ModalCancelButton} variant='link-default' size='sm' onClick={onCancel}>
            Cancel
          </Button>
          <Button variant='primary' size='sm' disabled={isConfirmButtonDisabled} onClick={onProceed}>
            Confirm
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

PromptModal.propTypes = {
  /**
   * modal Open
   */
  isOpen: PropTypes.bool,
  /**
   * Modal title
   */
  title: PropTypes.string,
  /**
   * Modal description/Body
   */
  message: PropTypes.string,
  /**
   * Function to execute on close button click
   */
  onCancel: PropTypes.func,
  /**
   * Function to execute on confirm button click
   */
  onProceed: PropTypes.func,
  /**
   * Disable confirm button
   */
  isConfirmButtonDisabled: PropTypes.bool
}

export default PromptModal
